import type { MonthlyNewClientsData } from '../../domain/statisticsClients';
import StandardChart from './StandardChart';

interface MonthlyNewClientsChartProps {
    readonly data: readonly MonthlyNewClientsData[];
    readonly loading?: boolean;
}

function MonthlyNewClientsChart({
    data,
    loading = false,
}: MonthlyNewClientsChartProps): JSX.Element {
    return (
        <StandardChart
            data={data.map(item => ({ date: item.period, value: item.newClients }))}
            loading={loading}
            config={{
                chartType: 'line',
                height: 350,
                yAxisTitleKey: 'statistics.clients.numberOfNewClients',
                yAxisTitleFallback: 'Number of new clients',
                yAxisColor: '#1890ff',
                seriesNameKey: 'statistics.clients.newClients',
                seriesNameFallback: 'New clients',
                seriesColor: '#1890ff',
            }}
        />
    );
}

export default MonthlyNewClientsChart;
